import React, { useState, useEffect } from "react";
import * as Icon from "react-bootstrap-icons";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

//Smooth Scroll
import { Link } from 'react-scroll';

function Contents7() {
  useEffect(() => { }, []);

  return (
    <>
      <h2 className="tag-title">その他お役立ち情報</h2>
      <h3 className='icon-title type-pencil' id='image'>オンラインMTG用壁紙</h3>
      <p>
        ZoomやGoogle
        Meet等、オンラインミーティング時にご使用頂ける背景画像となります。以下より背景画像をダウンロード出来ます。
      </p>
      <Row className='mt-5'>
        <Col sm={4}>
          <p>モノグラム</p>
          <img
            src={
              process.env.PUBLIC_URL + '/johsys_pic/mtg1.jpg'
            }
            alt='モノグラム'
          />
          <a
            className='btn main-btn type-download h-auto mt-3'
            id='monogram'
            href='/johsys_pic/mtg1.jpg'
            download
          >
            ダウンロード<br />(269KB)
          </a>
        </Col>
        <Col sm={4}>
          <p>オンライン背景A</p>
          <img
            src={
              process.env.PUBLIC_URL + '/johsys_pic/mtg2.jpg'
            }
            alt='オンライン背景A'
          />
          <a
            className='btn main-btn type-download h-auto mt-3'
            id='entrance'
            href='/johsys_pic/mtg2.pptx'
            download
          >
            ダウンロード<br />(Power Point)
          </a>
        </Col>
        <Col sm={4}>
          <p>オンライン背景B</p>
          <img
            src={
              process.env.PUBLIC_URL + '/johsys_pic/mtg3.jpg'
            }
            alt='オンライン背景B'
          />
          <a
            className='btn main-btn type-download h-auto mt-3'
            id='entrance2'
            href='/johsys_pic/mtg3.pptx'
            download
          >
            ダウンロード<br />(Power Point)
          </a>
        </Col>
      </Row>
      <Row className='mt-5'>
        <Col sm={4}>
          <p>オンライン背景C</p>
          <img
            src={
              process.env.PUBLIC_URL + '/johsys_pic/mtg4.jpg'
            }
            alt='オンライン背景C'
          />
          <a
            className='btn main-btn type-download h-auto mt-3'
            id='sokoninaimirai'
            href='/johsys_pic/mtg4.jpg'
            download
          >
            ダウンロード<br />(47KB)
          </a>
        </Col>
      </Row>
    </>
  );
}
export default Contents7;